
import {
  PermissionScopeMap,
  PermissionTypesMap
} from '@digitaix/types';

export const DEFAULT_PERMISSION_TYPES_MAP: PermissionTypesMap = {
  get: 'Anzeigen',
  list: 'Aufliste',
  delete: 'LÃ¶schen',
  create: 'Erstellen',
  update: 'Aktualisieren',
  archive: 'Archivieren'
};

export const DEFAULT_PERMISSION_SCOPES_MAP: PermissionScopeMap = {
  user: 'Benutzer',
  role: 'Rollen'
};
